import React, { Component } from "react";
import styles from "./Reporting.module.scss";
import { Grid } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import SubNav from "../../shared/subnav/SubNav";
import { base64FileDownload, fileDownload } from "../../utils/FileDownloadUtil";
import { logMsg } from "../../common/Logger";
import DownloadButton from "../../shared/buttons/DownloadButton";
import { InfoIconWithMessage } from "../../shared/infoIcon/InfoIcon";
import NscReportingClient from "../../shared/clients/NscReportingClient";
import AccessoriesSearchClient from "../../shared/clients/AccessoriesSearchClient";

class Reporting extends Component {
  constructor(props) {
    super(props);
    this.commonReport = [
      {
        name: "Reporting.report1Title",
        key: "report1",
        downloadLink: this.downloadDealerActivationReport.bind(this),
      },
    ];
    this.reports = this.getReports();
    this.state = {
      listOfMarkets: [],
    };
    this.showMarketDropDown =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "orderSearchMarketDropDown:view"
      );
  }

  componentDidMount() {
    this.setState({
      listOfMarkets: this.props.groups,
    });
  }

  onMarketChange = (event) => {
    event.preventDefault();
    const market = event.target.value;

    this.setState(
      {
        listOfMarkets: this.props.groups,
      },
      () => {
        this.props.updateCurrentMarket(market);
      }
    );
  };

  getReports = () => {
    if (
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "herculesReports"
      )
    ) {
      return [
        {
          name: "Reporting.report2Title",
          downLoadName: "Reporting.downloadDealerReport",
          key: "report2",
          downloadLink: this.downloadDealerReservationReportInXlsx.bind(this),
        },
      ];
    } else {
      return [
        ...this.commonReport,
        {
          name: "Reporting.report2Title",
          downLoadName: "Reporting.downloadDealerReport",
          key: "report2",
          downloadLink: this.downloadDealerReservationReportInXlsx.bind(this),
        },
        {
          name: "Reporting.report3Title",
          downLoadName: "Reporting.downloadPricingReport",
          key: "report3",
          downloadLink: this.downloadPricingReport.bind(this),
        },
        {
          name: "Reporting.report6Title",
          downLoadName: "Reporting.downloadAccessoryReport",
          key: "report4",
          downloadLink: this.downloadAccesoriesReport.bind(this),
        },
        {
          name: "Reporting.report8Title",
          downLoadName: "Reporting.downloadDeliveryRangesReport",
          key: "report5",
          downloadLink: this.downloadDeliveryRangesReport.bind(this),
        },
        {
          name: "Reporting.report9Title",
          downLoadName: "Reporting.downloadTransparentPricingReport",
          key: "report6",
          downloadLink: this.downloadTransparentPricingReport.bind(this),
        },
        {
          name: "Reporting.report10Title",
          downLoadName: "Reporting.downloadTransparentAccessoriesPricingReport",
          key: "report10",
          downloadLink:
            this.downloadTransparentAccessoriesPricingReport.bind(this),
        },
      ];
    }
  };

  downloadDealerActivationReport = (report) => {
    this.props.hideOrShow(true);
    NscReportingClient.downloadDealerActivationReportInCsv(
      this.props.user,
      this.props.selectedMarket
    )
      .then((res) => {
        const filename = this.props.t(report.name) + ".csv";
        const BOM = "\uFEFF";
        const response = BOM + res;
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  downloadDealerReservationReportInXlsx = (report) => {
    this.props.hideOrShow(true);
    NscReportingClient.downloadDealerReservationReportInXlsx(
      this.props.user,
      this.props.selectedMarket
    )
      .then((res) => {
        const filename = this.props.t(report.downLoadName) + ".xlsx";
        const BOM = "\uFEFF";
        const response = BOM + res;
        base64FileDownload(
          decodeURIComponent(response),
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          filename
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  downloadDealerReservationSummary = (report) => {
    this.props.hideOrShow(true);
    NscReportingClient.downloadDealerReservationSummary(
      this.props.user,
      this.props.selectedMarket,
      report.catalog
    )
      .then((response) => {
        const filename = this.props.t(report.downLoadName) + ".csv";
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename,
          "reservation-reports"
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  downloadPricingReport = (report) => {
    this.props.hideOrShow(true);
    NscReportingClient.downloadPricingReport(
      this.props.user,
      this.props.selectedMarket
    )
      .then((response) => {
        const filename = this.props.t(report.downLoadName) + ".csv";
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename,
          "pricing-report"
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  downloadTransparentPricingReport = (report) => {
    this.props.hideOrShow(true);
    NscReportingClient.downloadTransparentPricingReport(
      this.props.user,
      this.props.selectedMarket
    )
      .then((response) => {
        const filename = this.props.t(report.downLoadName) + ".csv";
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename,
          "transparent-pricing-report"
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  downloadTransparentAccessoriesPricingReport = (report) => {
    this.props.hideOrShow(true);
    NscReportingClient.downloadTransparentAccessoriesPricingReport(
      this.props.user,
      this.props.selectedMarket
    )
      .then((response) => {
        const filename = this.props.t(report.downLoadName) + ".csv";
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename,
          "transparent-accessories-pricing-report"
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  downloadAccesoriesReport = (report) => {
    this.props.hideOrShow(true);
    AccessoriesSearchClient.downloadAccessories(
      this.props.user,
      this.props.selectedMarket
    )
      .then((response) => {
        const filename = this.props.t(report.downLoadName) + ".csv";
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename,
          "accessory-report"
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };
  downloadDeliveryRangesReport = (report) => {
    this.props.hideOrShow(true);
    NscReportingClient.downloadDealerDeliveryRangesInCsv(
      this.props.user,
      this.props.selectedMarket
    )
      .then((response) => {
        const filename = this.props.t(report.downLoadName) + ".csv";
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename,
          "delivery-ranges-report"
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };
  render() {
    return (
      <div id="reporting">
        <section className="pageWrapper">
          <div id="reportingHeader">
            <SubNav
              dashboard={false}
              showCustomMarketDropdown={
                this.state.listOfMarkets &&
                this.state.listOfMarkets.length > 1 &&
                this.showMarketDropDown
              }
              title={this.props.t("Reporting.subnav1")}
              listOfMarkets={this.state.listOfMarkets}
              updateMarket={this.onMarketChange}
              value={this.props.selectedMarket}
              {...this.props}
            />
          </div>
          <div className="pagePaddingLeft pagePaddingTop">
            <InfoIconWithMessage message={this.props.t("Reporting.bodyCopy")} />
          </div>
          <div className={styles.wrapper}>
            <Grid container>
              <Grid
                item
                className={`${styles.headerContainer} ${styles.rowDiv} pagePaddingLeft pagePaddingRight`}
              >
                <div>{this.props.t("Reporting.columnTitle1")}</div>
              </Grid>
              {this.reports.map((report) => (
                <React.Fragment key={report.key}>
                  <Grid
                    container
                    className={`${styles.rowDiv} pagePaddingLeft pagePaddingRight`}
                  >
                    <Grid item md={10}>
                      <div className={styles.colValues}>
                        {this.props.t(report.name)}
                      </div>
                    </Grid>
                    <Grid item md={2} className={`${styles.end}`}>
                      <DownloadButton
                        // eslint-disable-next-line react/jsx-no-bind
                        download={report.downloadLink.bind(this, report)}
                        text={this.props.t("Reporting.download")}
                      />
                    </Grid>
                  </Grid>
                </React.Fragment>
              ))}
            </Grid>
          </div>
        </section>
      </div>
    );
  }
}

export default withTranslation("emp")(Reporting);
